import React, { useState } from "react"
import { graphql } from "gatsby"
import CommonTemplate from "templates/common-template"
import { Box, Flex, Button, Container } from "theme-ui"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import styled from "@emotion/styled"
import Modal from "components/modal"
import ContactForm from "components/contact-form"
import GetHelp from "components/get-help"
import ShareButtonSocial from "components/share-button-social"
import { IoLogoWhatsapp } from "@react-icons/all-files/io/IoLogoWhatsapp"
import { useBreakpointIndex } from "@theme-ui/match-media"
import * as componentStyle from "assets/css/components.module.css"

const Wrapper = styled.div`
    & .image-circle {
        display: inline-block;
        position: relative;
        width: 250px;
        height: 250px;
        overflow: hidden;
        border-radius: 50%;

        & img {
            width: auto;
            height: 100%;
        }
        @media screen and (max-width: ${(props) =>
                props.theme.breakpoints[4]}) {
            width: 200px;
            height: 200px;
        }
    }

    & .profile-box {
        width: 100%;
        flex-direction: column;
        padding-left: 4rem;
        @media screen and (max-width: ${(props) =>
                props.theme.breakpoints[3]}) {
            margin-top: 1rem;
            padding-left: 0;
        }
    }

    & .profile-detail {
        margin-bottom: 1rem;
        & h4 {
            font-family: Playfair Display;
            margin: 0;
            color: ${(props) => props.theme.colors.primary};
        }
        & p {
            color: ${(props) => props.theme.colors.text1};
        }
    }

    & .qualification-box {
        margin-top: 1rem;
        padding-top: 1rem;
        & p {
            color: ${(props) => props.theme.colors.text1};
        }

        & .qualification-detail {
            margin: 1rem 0;
            & p {
                color: ${(props) => props.theme.colors.text1};
                margin-bottom: 1rem;
                margin: 0.2rem;
            }
        }
    }

    & .appointment-btn {
        cursor: pointer;
        font-size: 14px;
        padding: 0.5rem 1rem;
        border-radius: 0;
        background: ${(props) => props.theme.colors.secondary};
        color: ${(props) => props.theme.colors.background};
    }
`

const ProfileWrapper = styled.div`
    margin-bottom: 1rem;
    & .green-box {
        border-radius: 1rem;
        padding: 2rem;
        background: #fafff3;
        flex-direction: row;
    }
`

// markup
const IndexPage = ({ location, data }) => {
    const breakpointIndex = useBreakpointIndex()
    const { post } = data
    const [open, setOpen] = useState(false)

    let qualification = []
    let memberships = []

    post.profiledata.forEach((el) => {
        if (el.qualifiications) {
            qualification = [...el.qualifiications]
        } else if (el.memberships) {
            memberships = [...el.memberships]
        }
    })

    const showModal = () => {
        setOpen(true)
    }

    const hideModal = () => {
        setOpen(false)
    }
    const customJsx = (
        <Wrapper>
            <ProfileWrapper>
                <Box className="green-box">
                    <Container>
                        <Flex
                            sx={{
                                flexDirection:
                                    breakpointIndex > 4 ? "row" : "column",
                            }}
                        >
                            <Box sx={{ marginRight: "1rem" }}>
                                <div className="image-circle">
                                    {post.image && (
                                        <GatsbyImage
                                            image={getImage(post.image)}
                                            alt={post.name}
                                        />
                                    )}
                                </div>
                                <br />
                            </Box>
                            <Flex className="profile-box">
                                <Flex
                                    sx={{
                                        justifyContent: "space-between",
                                        flexWrap: "wrap",
                                        alignItems: "center",
                                    }}
                                >
                                    <Box className="profile-detail">
                                        <h4>{post.name}</h4>
                                        <p>{post.title}</p>
                                    </Box>
                                    <Box>
                                        <Button
                                            sx={{ fontSize: 0 }}
                                            className="appointment-btn"
                                            onClick={showModal}
                                        >
                                            <span
                                                className={
                                                    componentStyle.reactIcons
                                                }
                                            >
                                                <IoLogoWhatsapp size={25} />
                                            </span>
                                            Book An Appointment
                                        </Button>
                                        <Modal
                                            show={open}
                                            handleClose={hideModal}
                                        >
                                            <ContactForm />
                                        </Modal>
                                    </Box>
                                </Flex>
                                <Flex
                                    sx={{
                                        justifyContent: "space-between",
                                        flexWrap: "wrap",
                                    }}
                                >
                                    <Box className="qualification-box">
                                        <p>
                                            <strong>Qualification</strong>
                                        </p>
                                        {qualification.map((qua, index) => (
                                            <div
                                                className="qualification-detail"
                                                key={index}
                                            >
                                                <p>{qua.title}</p>
                                                <p>{qua.institution}</p>
                                            </div>
                                        ))}
                                    </Box>
                                    <Box className="qualification-box">
                                        <p>
                                            <strong>
                                                Professional Memberships
                                            </strong>
                                        </p>
                                        {memberships.map((member, index) => (
                                            <div
                                                className="qualification-detail"
                                                key={index}
                                            >
                                                <p>{member.description}</p>
                                                <p>{member.country}</p>
                                            </div>
                                        ))}
                                    </Box>
                                </Flex>
                            </Flex>
                        </Flex>
                    </Container>
                </Box>
            </ProfileWrapper>
            <Flex>
                <Box>
                    <div
                        dangerouslySetInnerHTML={{ __html: post.descriptions }}
                    />
                </Box>
            </Flex>
            <ShareButtonSocial path={location.pathname} url={location.href} />
            <GetHelp />
        </Wrapper>
    )

    let path = location.pathname.split("/").filter((splitted) => splitted)
    let title = path[1]
        .split("-")
        .map((str) => str.charAt(0).toUpperCase() + str.slice(1))
        .join(" ")
    const breadcrumbs = ["Our Teams", title]

    const arrData = {
        location,
        data,
        parentLink: "our-teams",
        customElement: customJsx,
        breadcrums: breadcrumbs, // allow null
    }

    return <CommonTemplate {...arrData} />
}

export default IndexPage

export const query = graphql`
    query OurTeamsMemberQuery($slug: String!) {
        pageData: strapiPage(slug: { eq: "wns-our-teams" }) {
            title
            menu_title
            description
            summary
            image {
                childImageSharp {
                    gatsbyImageData(placeholder: BLURRED, width: 230)
                }
            }
            metadata {
                description
                title
                OG_type
                OG_image {
                    publicURL
                    name
                    childImageSharp {
                        resize(width: 1200, height: 630, cropFocus: CENTER) {
                            src
                        }
                    }
                }
            }
            image {
                childImageSharp {
                    resize(width: 1200, height: 630, cropFocus: CENTER) {
                        src
                    }
                }
            }
            category {
                category_img {
                    publicURL
                }
            }
            content {
                Single_Column {
                    Text_Alignment
                    content
                    id
                    title
                }
            }
        }
        post: strapiProfile(slug: { eq: $slug }) {
            name
            title
            descriptions
            image {
                childImageSharp {
                    gatsbyImageData(
                        placeholder: BLURRED
                        width: 250
                        height: 250
                    )
                    id
                }
            }
            profiledata {
                qualifiications {
                    institution
                    title
                }
                memberships {
                    country
                    description
                    title
                }
            }
        }
    }
`
